//import axios from 'axios';
import React,{useEffect} from 'react'
import {Link} from 'react-router-dom'
import ToggleBar from '../../common/Util';

function KeyDriver() {
    useEffect(()=>{
        ToggleBar()
/* 
        axios.get('https://prod-apnortheast-a.online.tableau.com/t/rahulpal/newWorkbook/p/86761/1evck1988$ecs6-qa-ht-qp-hmwbgb#1').then((res)=>{
          console.log(res.data)
        }).catch((err)=>{
          console.log(err)
        }) */
    },[])
    return (
        <>
            <div className="page-wrapper position-relative overflow-hidden">
  <div className="position-sticky p-0 shadow z-index-1 bg-white px-sm-4 px-3">
    <div className="row mr-lg-0">
      <div className="col-md-12">
        <div className="navbar-custom   position-relative d-flex align-items-center">
          <Link to="/" className="d-md-none mr-3"><img src="assets/images/logo-sm.png" className="img-fluid logo-mob-icon" alt="img" /></Link>
          <button type="button" className="top-togglebar bg-transparent border-0">
            <img src="assets/images/menu.svg" className="img-fluid" alt="img" />
          </button>
          <div className="theme-custom-select position-relative ml-3 diable-enable-select border-0 brand-dropdown">
            <select className="form-control  border-0">
              <option className="py-4" value="alert type">Royal Canin</option>
              <option className="py-4" value="alert">Zevo</option>
            </select>
          </div>
          <div className="ml-auto">
            <ul className="list-unstyled mb-0 ">
              <li className="list-inline-item mx-2 d-sm-inline-block d-none"><img src="assets/images/royal-chain.jpg" className="img-fluid" alt="royal" /></li>
              <li className="list-inline-item ml-2">
                <div className="dropdown  profile-detail py-1 pr-sm-3">
                  <a className="dropdown-toggle mr-2" href="#!" id="dropdown03" data-toggle="dropdown" /* aria-haspopup="true" */ aria-expanded="true">
                    <img src="assets/images/user.jpg" className="img-fluid rounded-circle user-name mx-2" alt="img" />
                    <span className="d-none d-sm-inline-block pr-2 font-poppins">Amella</span>
                  </a>
                  <div className="dropdown-menu d-none " aria-labelledby="dropdown03">
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="page-content-tab px-4 py-3 review-keywords overflow-auto">
  <div className="row mb-3 align-items-center">
        <div className="col">
          <ul className="breadcrumb  pl-md-3 pl-0 list-unstyled mb-0 bg-transparent">
            <li className="h5 mb-0 font-poppins"><a href="#!">Royal Canin</a></li>
            <li><img src="assets/images/right-arrow.svg" className="img-fluid breadcrumb-arrow" alt="arrow" /></li>
            <li className="h5 mb-0 font-poppins"><a href="#!" className="font-weight-semibold">Key Drivers</a></li>
          </ul>
        </div>
      
      </div>
    <div className="row h-100">
      <div className="left-section bg-white">
        <div className="d-flex border-bottom px-3 metric-keyword-period">
          <div className="border-right py-3 px-4 common-width">
            <h6 className="font-weight-600 text-uppercase font-12">Metric</h6>
            <div className="ml-auto">
              <div className="dropdown w-100 show dropdown-green position-relative">
                <a className="dropdown-toggle font-12 mr-2 w-100" href="#!" id="dropdown-all" data-toggle="dropdown" /* aria-haspopup="true" */ aria-expanded="true">
                  <span className="d-none d-sm-inline-block w-100 pr-4 font-poppins font-12 font-weight-600">Filtered Metrics</span>
                </a>
                <div className="dropdown-menu show d-none" aria-labelledby="dropdown-all" style={{willChange: 'transform', position: 'absolute', transform: 'translate3d(88px, 18px, 0px)', top: 0, left: 0}} x-placement="bottom-start">
                  1
                </div>
              </div>
            </div>
          </div>
          <div className="border-right py-3 px-4 common-width">
            <h6 className="font-weight-600 text-uppercase font-12">Period</h6>
            <div className="ml-auto">
              <div className="dropdown w-100 show dropdown-green">
                <a className="dropdown-toggle w-100 mr-2 font-12" href="#!" id="dropdown-all" data-toggle="dropdown" /* aria-haspopup="true" */ aria-expanded="true">
                  <span className="d-none w-100 d-sm-inline-block pr-4 font-poppins font-12 font-weight-600">Data Range - Data Range</span>
                </a>
                <div className="dropdown-menu show d-none" aria-labelledby="dropdown-all" style={{willChange: 'transform', position: 'absolute', transform: 'translate3d(88px, 18px, 0px)', top: 0, left: 0}} x-placement="bottom-start">
                  1
                </div>
              </div>
            </div>
          </div>
          <div className="border-right py-3 px-4 common-width">
            <h6 className="font-weight-600 text-uppercase font-12">Comparison period</h6>
            <div className="ml-auto">
              <div className="dropdown w-100 show dropdown-green">
                <a className="dropdown-toggle w-100 mr-2 font-12" href="#!" id="dropdown-all" data-toggle="dropdown" /* aria-haspopup="true" */ aria-expanded="true">
                  <span className="d-none w-100 d-sm-inline-block pr-4 font-poppins font-12 font-weight-600">Data Range - Data Range</span>
                </a>
                <div className="dropdown-menu show d-none" aria-labelledby="dropdown-all" style={{willChange: 'transform', position: 'absolute', transform: 'translate3d(88px, 18px, 0px)', top: 0, left: 0}} x-placement="bottom-start">
                  1
                </div>
              </div>
            </div>
          </div>
          <div className=" py-3 px-4 common-width">
          </div>
        </div>
        <div className="py-3 bg-light-gray d-flex align-items-center px-4 border-bottom">
          <div className="form-control d-flex align-items-center keywords-input rounded">
            <div className="d-flex align-items-center">
              <a href="#!"> <img src="assets/images/cancel.svg" className="img-fluid w-13 mr-3" alt="cancel"/></a>
              <span className="text-muted  font-12 mr-4">Brand</span>
            </div>
            <div className="d-flex align-items-center">
              <a href="#!"> <img src="assets/images/cancel.svg" className="img-fluid w-13 mr-3" alt="cancel"/></a>
              <span className="text-muted  font-12 mr-4">Royal Canin</span>
            </div>
            <div className="dropdown  show dropdown-green">
              <a className="dropdown-toggle font-12 mr-2" href="#!" id="dropdown-all" data-toggle="dropdown" /* aria-haspopup="true" */ aria-expanded="true">
                <span className="d-none d-sm-inline-block pr-2 font-poppins font-12">Urinary</span>
              </a>
              <div className="dropdown-menu show d-none" aria-labelledby="dropdown-all" style={{willChange: 'transform', position: 'absolute', transform: 'translate3d(88px, 18px, 0px)', top: 0, left: 0}} x-placement="bottom-start">
                1
              </div>
            </div>
          </div>
          <div className="form-control d-flex align-items-center keywords-input rounded ml-3">
            <div className="d-flex align-items-center">
              <a href="#!"> <img src="assets/images/cancel.svg" className="img-fluid w-13 mr-3" alt="cancel" /></a>
              <span className="text-muted  font-12 mr-4">Themes</span>
            </div>
            <div className="d-flex align-items-center">
              <a href="#!"> <img src="assets/images/cancel.svg" className="img-fluid w-13 mr-3" alt="cancel" /></a>
              <span className="text-muted  font-12 mr-4">Packaging</span>
            </div>
            <div className="d-flex align-items-center">
              <a href="#!"> <img src="assets/images/cancel.svg" className="img-fluid w-13 mr-3" alt="cancel" /></a>
              <span className="text-muted  font-12 mr-4">Taste</span>
            </div>
            <div className="dropdown  show dropdown-green">
              <a className="dropdown-toggle font-12 mr-2" href="#!" id="dropdown-all" data-toggle="dropdown" /* aria-haspopup="true" */ aria-expanded="true">
                <span className="d-none d-sm-inline-block pr-2 font-poppins font-12">Flavour</span>
              </a>
              <div className="dropdown-menu show d-none" aria-labelledby="dropdown-all" style={{willChange: 'transform', position: 'absolute', transform: 'translate3d(88px, 18px, 0px)', top: 0, left: 0}} x-placement="bottom-start">
                1
              </div>
            </div>
          </div>
          <a href="#!" className="font-12 font-weight-600 px-4">Add Filter</a>
        </div>
        <div className="text-center py-5 my-5">
          <img src="assets/images/plot-1.jpg" className="img-fluid" alt="review-graph" />
        </div>
      </div>
      <div className="sidebar position-absolute bg-white border-left">
        <div className="p-4">
          <a href="#!" className="font-12">All Drivers</a>
          <h6 className="font-12 font-weight-600 my-2">Net Sentiment</h6>
          <h1 className="text-danger font-weight-light">-29.4</h1>
          <img src="assets/images/graph.jpg" className="img-fluid" alt="graph" />
        </div>
        <hr />
        <div className="px-4 sidebar-content-driver  overflow-auto">
          <div className="d-flex py-3">
            <span className="text-success mr-3">9</span>
            <div className="border-bottom pb-4 client-chat">
              <p className="font-12 mb-0">The vet recommended this food for diet and exercise. The food is less than 300 kcal/cup. Dog loves it and is acting more active than before because he is losing weight and getting more exercise. When he loses his 10lbs, I will mix his older kibble in as a ratio of 1 to 3 cups of this gastro food, while maintaining his 5 miles of walks per day.</p>
              <small className="text-muted">3 hours . Review</small>
            </div>
          </div>
          <div className="d-flex py-3">
            <span className="text-danger mr-3">5</span>
            <div className="border-bottom pb-4 client-chat">
              <p className="font-12 mb-0">Very good product but this small bag of dog food is insanely expensive.</p>
              <small className="text-muted">yerterday . Nps survey</small>
            </div>
          </div>
          <div className="d-flex py-3">
            <span className="text-success mr-3">9</span>
            <div className="border-bottom pb-4 client-chat">
              <p className="font-12 mb-0">Vet said if I wanted him to live he must be on a low fat diet, first tried Hills, he would not touch it. He likes this mixed wit Royal Canin wet food!</p>
              <small className="text-muted">3 days ago . Nps survey </small>
            </div>
          </div>
          <div className="d-flex py-3">
            <span className="text-muted mr-3">8</span>
            <div className="border-bottom pb-4 client-chat">
              <p className="font-12 mb-0">Let me start by saying I was one of the worst offenders for being 100% against my dogs eating Hill's Science Diet. I was told that it contained lots of toxic chemicals and was only pushed on consumers by vets because they were paid by Hill's to push the product. My opinion has since changed since using this product. I have three boxers. One is in perfect health, the other suffers from terrible skin allergies, and the last has a very sensitive stomach due a stomach flip he had surgery for when his previous owners fed him a sock with food on it to try and kill him -- because of this, he has terrible farts.

Since I've been using this product (close to a month now), my allergy dog no longer scratches herself all day and my little tooter dog no longer farts. I am literally amazed. We tried everything from Taste of the Wild, Blue Buffalo, Royal Canin, Nutrish, etc. and nothing has worked for out dogs but this product. I cannot even begin to say how thankful I am we tried this food.

While I understand all vets have different opinions, but vet advised my husband and I to steer clear of "grain-free" foods. This really surprised me, because I always thought that they would be healthier for my pups and would prolong their life. Apparently, this is not the case. Through extensive research, they are finding that these types of foods are actually limiting the life of pup's due to the higher fat contents, which in turn wears down their heart much quicker (apologies if I didn't explain this correctly; trying to parrot what my vet said).

Moving forward, I'll be using this product and would not hesitate to recommend it to other pet owners who experience the same issues with their pups as I do.</p>
              <small className="text-muted">3 days ago . Nps survey </small>
            </div>
          </div>
        </div>
        <div className="bottom-section position-absolute w-100 border-top p-4 bg-light-gray">
          <div className="d-flex align-items-center">
            <div className="d-flex  align-items-center">
              <h2 className="font-weight-bold mb-0">1,435 </h2>
              <small className="font-10 total-small ml-2">Responses <br />total</small>
            </div>
            <a href="#!" className="btn btn-light ml-auto border bg-white py-2 px-3 rounded font-weight-bold">View all</a>
          </div>
        </div>
      </div>
      <div className="row py-4 copy-right">
        <div className="col-12 ">
          <p className="text-center text-muted mb-0">Copyright © 2021. All rights reserved.</p>
        </div>
      </div>  
    </div>
  </div>
</div>

        </>
    )
}

export default KeyDriver
